import { useState } from 'react'
import styles from '@/components/directory/v2/card-view/EVsCardItemVariantComponent.module.css'
import Link from 'next/link'
import PriceIndicator from '@/components/ui/attributes/v2/PriceIndicator'

const EVsCardItemVariantComponent = ({ variant }) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const {
    slug,
    make,
    model,
    year,
    vehicle_id,
    description,
    images,
    attributes,
    basic_details,
    price_category,
    status,
    min_price_category,
    max_price_category,
  } = variant

  if (!variant) {
    return null // or a loading indicator
  }

  const getStatusText = (statusCode) => {
    switch (statusCode) {
      case 0:
        return 'Available used'
      case 1:
        return 'Available new'
      case 2:
        return 'Pre-order'
      case 3:
        return 'Coming soon'
      case 91:
        return 'Coming soon'
      default:
        return 'Concept car' // Fallback for unknown codes
    }
  }

  const getStatusClass = (statusCode) => {
    switch (statusCode) {
      case 0:
        return styles.availableUsed
      case 1:
        return styles.availableNew
      case 2:
        return styles.preOrder
      case 3:
      case 91:
        return styles.comingSoon
      default:
        return styles.conceptCar
    }
  }

  // Determine the source of the image
  const hasImages = Array.isArray(images) && images.length > 0
  const imageUrl = hasImages ? images[0].image_url : '/illustrations/v2/EV-v1.png'
  const imageClassName = hasImages ? styles.cardImage : styles.fallBackImage
  const containerClassName = hasImages ? styles.imageContainer : styles.fallbackImageContainer

  // Image loading event handlers
  const handleImageLoad = () => {
    setImageLoaded(true)
  }

  // Helper function to determine display value and unit
  const getDisplayValues = (attr) => {
    if (attr.unit === 'null' || attr.unit === null) {
      return { displayValue: attr.value, displayUnit: '' }
    } else {
      return { displayValue: attr.value, displayUnit: attr.unit }
    }
  }

  const { displayValue: displayValue1, displayUnit: displayUnit1 } = getDisplayValues(attributes[1])

  return (
    <Link href={`/directory/${slug}`} className={styles.container}>
      <div className={styles.group1}>
        <div className={styles.headerRow}>
          <div className={styles.name}>{`${make} ${model}`}</div>

          <div className={styles.headerAttribute}>
            <span className={`${styles.attributePill} ${getStatusClass(status)}`}>{getStatusText(status)}</span>
          </div>
        </div>
        <div className={styles.headerRow}>
          <div className={styles.variant}>{basic_details[2].value}</div>
          <div className={styles.year}>{year}</div>
        </div>

        <div className={styles.headerRow}>
          <div className={styles.headerAttribute}>
            <span className={styles.attributeValue}>{basic_details[4].value}</span>{' '}
            <span className={styles.attributeUnit}>{basic_details[4].unit}</span>
          </div>

          <div className={styles.price}>
            {/*<PriceIndicator min_price_category={min_price_category} max_price_category={max_price_category} />*/}
          </div>
        </div>
      </div>
      <div className={styles.picture}>
        <div className={containerClassName}>
          {!imageLoaded && <div className={styles.loader}></div>}
          <img
            className={imageClassName}
            src={imageUrl}
            alt={`${make} ${model}`}
            onLoad={handleImageLoad}
            style={{ display: imageLoaded ? 'block' : 'none' }}
          />
        </div>
      </div>

      <div className={styles.attributes}>
        <div className={styles.attribute}>
          <div className={styles.attributeData}>
            <span className={styles.attributeValue}>{attributes[0].value}</span>
            <span className={styles.attributeUnit}>{attributes[0].unit}</span>
          </div>
          <div className={styles.attributeName}>{attributes[0].attribute}</div>
        </div>
        <div className={styles.attribute}>
          <div className={styles.attributeData}>
            <span className={styles.attributeValue}>{displayValue1}</span>
            {displayUnit1 && <span className={styles.attributeUnit}>{displayUnit1}</span>}
          </div>
          <div className={styles.attributeName}>{attributes[1].attribute}</div>
        </div>
        <div className={styles.attribute}>
          <div className={styles.attributeData}>
            <span className={styles.attributeValue}>{attributes[2].value}</span>
            <span className={styles.attributeUnit}>{attributes[2].unit}</span>
          </div>
          <div className={styles.attributeName}>{attributes[2].attribute}</div>
        </div>
      </div>
    </Link>
  )
}

export default EVsCardItemVariantComponent
